'use strict';

module.exports = {
  'name': 'asec',
  'category': 'Trigonometry',
  'syntax': ['asec(x)'],
  'description': 'Calculate the inverse secant of a value.',
  'examples': ['asec(0.5)', 'asec(sec(0.5))', 'asec(2)'],
  'seealso': ['acos', 'acot', 'acsc']
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/function/trigonometry/asec.js
// module id = 1505
// module chunks = 3